import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createIVR } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useCreateIVR({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const queryclient = useQueryClient();
  const Request = useMutation({
    mutationFn: createIVR,
    mutationKey: ['createIVR'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter('error', responseData?.error?.message);
      }
      handleSuccess();
      queryclient.invalidateQueries(['getIVRList']);
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
